import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito comprar comida cara o especial?',
  a: 'No. Todo se consigue en cualquier supermercado normal como Walmart, Publix o Target.',
  icon: '✅'
}, {
  q: '¿Funciona si trabajo y tengo poco tiempo?',
  a: 'Absolutamente. El protocolo fue diseñado para mujeres con vida real y ocupada.',
  icon: '✅'
}, {
  q: '¿Puedo hacerlo si ya no tengo vesícula biliar?',
  a: 'Sí, y de hecho lo necesitas más. El protocolo incluye una sección especial para este caso.',
  icon: '✅'
}, {
  q: '¿Cuándo recibo los materiales?',
  a: 'Inmediatamente después de tu compra. Acceso digital instantáneo desde tu teléfono o computadora.',
  icon: '✅'
}, {
  q: '¿Tengo acceso de por vida?',
  a: 'Sí. Puedes repetir el protocolo cada vez que sientas que tu cuerpo necesita un reseteo.',
  icon: '✅'
}, {
  q: '¿Esto reemplaza la consulta médica?',
  a: 'Este es un protocolo de nutrición natural. No reemplaza el diagnóstico médico. Siempre consulta a tu médico para condiciones graves.',
  icon: '⚠️'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionWrapper bgColor="warmWhite" data-id="element-66">
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-dark mb-6 leading-tight text-center" data-id="element-67">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-3" data-id="element-68">
        {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-69">
            <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-5 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-70">
              <span className="font-bold text-dark text-lg pr-4 flex gap-3" data-id="element-71">
                <span className="text-primary" data-id="element-72">❓</span>
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-73" />
            </button>

            <AnimatePresence data-id="element-74">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-75">
                  <div className="px-6 pb-5 pt-0 border-t border-gray-50 mt-2 flex gap-3" data-id="element-76">
                    <span data-id="element-77">{faq.icon}</span>
                    <p className="text-gray-600 font-sans" data-id="element-78">{faq.a}</p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </SectionWrapper>;
}